import { useMemo } from 'react';
import { TicketType } from '@/api/constant';
import { useCartQuery } from './useCartQuery';
import { emptyShoppingCart } from '@/api/registration';

export function useIsEmptyRegisTypeInCart(eventId: string) {
  const { data: shoppingCart = emptyShoppingCart, isFetched } = useCartQuery(eventId);
  const isEmptyMainTicketInCart = useMemo(() => {
    if (!isFetched) return;
    const hasMainTicket = shoppingCart.cartItems?.some((item) => {
      return item.ticketType === TicketType.Main;
    });
    return !hasMainTicket;
  }, [shoppingCart.cartItems, isFetched]);

  return { isEmptyMainTicketInCart };
}
